<template>
  <div class="events-view container py-5">
    <!-- Header -->
    <div class="text-center mb-5">
      <h2 class="fw-bold text-gold">Upcoming Events</h2>
      <p class="text-muted">
        Join us in our spiritual gatherings and activities
      </p>
    </div>

    <!-- Event Cards -->
    <div class="row g-4">
      <div
        class="col-md-6 col-lg-4"
        v-for="(event, index) in events"
        :key="index"
      >
        <div class="card border-0 shadow-sm h-100 event-card">
          <img
            :src="event.image"
            class="card-img-top event-image"
            :alt="event.title"
          />
          <div class="card-body text-center text-md-start">
            <h5 class="card-title fw-bold text-gold">{{ event.title }}</h5>
            <p class="card-text text-muted mb-2">
              <i class="bi bi-calendar-event me-1"></i> {{ event.date }}
            </p>
            <p class="card-text">{{ event.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import vesak from "@/assets/events/vesak.jpg";
import meditation from "@/assets/events/meditation.jpg";
import katina from "@/assets/events/katina.jpg";

const events = [
  {
    title: "Vesak Celebration",
    date: "May 23, 2025",
    description:
      "Join us for a day of Dhamma sermons, lantern lighting, and meditation to honor the birth, enlightenment, and passing of the Buddha.",
    image: vesak,
  },
  {
    title: "Monthly Meditation Retreat",
    date: "December 15, 2025",
    description:
      "A full-day mindfulness retreat with guided meditations and teachings by the resident monks.",
    image: meditation,
  },
  {
    title: "Katina Ceremony",
    date: "November 25, 2025",
    description:
      "An annual robe-offering ceremony symbolizing gratitude towards the Sangha after the rainy retreat.",
    image: katina,
  },
];
</script>

<style scoped>
/* 🌸 Theme colors */
.text-gold {
  color: #c69f59;
}

/* 🌺 Card Styles */
.event-card {
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.event-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.event-image {
  height: 220px;
  object-fit: cover;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

/* 📱 Responsive */
@media (max-width: 991px) {
  .events-view {
    padding: 2rem 1rem;
  }
  .event-image {
    height: 200px;
  }
}

@media (max-width: 576px) {
  .event-image {
    height: 180px;
  }
}
</style>
